import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8hucttfmc: FaireProductEntity = {
  token: "p_x8hucttfmc",
  type: "product",
  name: "Squirrel and nut tea towel",
  brandToken: "b_zqgv7epztb",
  brandName: "Nice life",
  imageUrl:
    "https://cdn.faire.com/fastly/03eda47fd256829610f71816b7f4d7baf4013b57ab3f92c455a3bed7ad96b665.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8d79c9ae14d468294bab7c549a0e1cc6847b7f9822947cb7f9cd887150511ee.jpeg",
    "https://cdn.faire.com/fastly/2ed4a5907b80be60eba05a0734845d3d2e00c55226307860167f14c98ef09220.jpeg",
    "https://cdn.faire.com/fastly/b537018fe505e48f54ab25095f48f0bbc6d533063e4a52d4d421ee891aaf71bb.jpeg",
    "https://cdn.faire.com/fastly/af8003953f32081d08ca81ab42f14fea182738cb7dceba9a4c939795acf7c9fb.jpeg",
  ],
  priceDollars: 10,
  description:
    "Welcome to the whimsical world of Nice Life. Our Squirrel and nut Tea Towel is an essential addition to your kitchen. Crafted in our Detroit-based artist studio, each piece is screen printed and hand-cured, embodying our commitment to small batch production. Our meticulous process ensures every towel meets our standards. Embrace our sustainable and eco-friendly approach to home living. Brighten your kitchen experience with our unique, playful design.\n\n100% natural cotton flour sack tea towel\n\n19” by 19”\n\nScreenprinted with water based ink\n\nEach towel is individually screen printed and cured in my studio by hand - therefore please allow slight variance in detail as this is meant to enhance the beauty of a hand printed item by the artist.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:58.225Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
